import { Navigate, Outlet, useLocation } from "react-router-dom"
import { getUser } from "./auth"

interface RequireRoleProps {
	role: string
	/** Where to send users who lack the role (default: ventas). */
	fallback?: string
}

/** Ensures the authenticated user has the given role. */
export default function RequireRole({ role, fallback = "/admin/ventas" }: RequireRoleProps): React.JSX.Element {
	const location = useLocation()
	const user = getUser()

	if (!user || user.role !== role) {
		return <Navigate to={fallback} replace state={{ from: location.pathname }} />
	}

	return <Outlet />
}
